<template>
  <div class="pb-5 d-flex justify-content-end min-vh-100">
    <SideBar />
    <div class="body">
      <div class="header">
        <h1>聯絡我們</h1>
      </div>
      <div class="content">
        <div
          v-for="item in userInfo"
          :key="item"
          class="col-12 d-flex align-items-center justify-content-between pt-4 col-12"
        >
          <p class="text-nowrap col-2 text-center">{{ item.label }}</p>
          <div class="col-10 d-flex align-items-center position-relative">
            <input
              class="rounded-pill info"
              v-model="item.value"
              :type="item.type"
              :placeholder="item.placeholder"
            />
          </div>
        </div>
        <div class="position-relative d-flex align-items-center pb-4 col-12">
          <span class="text-nowrap col-2 text-center mt-1">問題分類</span>
          <div
            class="d-flex align-items-center col-10"
            style="width: 100%; flex-wrap: wrap"
          >
            <div
              class="position-relative d-flex align-items-center justify-content-between pt-4 pb-4 col-10"
            >
              <select v-model="messageType" class="rounded-pill state col-12" style="color: #000;">
                <option
                  v-for="option in type"
                  :value="option.value"
                  :key="option"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="col-12 d-flex align-items-center justify-content-between col-12"
        >
          <span class="text-nowrap col-2 text-center">問題</span>
          <div class="col-10 d-flex align-items-center position-relative">
            <textarea
              class="textarea pt-3"
              v-model="questionContent"
              placeholder="請輸入問題內容，我們會儘快與您聯繫。"
            >
            </textarea>
          </div>
        </div>
        <div class="col-12 d-flex align-items-center justify-content-center">
          <button
            @click="submit"
            class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
          >
            完成
          </button>
        </div>
      </div>
    </div>
  </div>
  <MsgBox :show="showMsgBox" :errorMsg="errorMsg" @close="showMsgBox = false" />
</template>
<script>
import { ref } from '@vue/reactivity'
import { computed, onMounted } from '@vue/runtime-core'
import { useRouter } from 'vue-router'
import SideBar from '@/views/Contact/ContactSideBar.vue'
import MsgBox from '@/components/MsgBox.vue'
import useInfo from '@/composables/useInfo'
import toggleLoading from '@/plugins/LoadingSpinner'
import { getUserInfo } from '@/api/Info'
export default {
  components: {
    SideBar,
    MsgBox,
  },
  setup() {
    const router = useRouter()
    const showMsgBox = ref(false)
    const showPassword = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const name = ref('')
    const state = ref('1')
    const formList = ref([])
    const showPhoto = ref(false)
    const image = ref('')
    const { userContact } = useInfo()
    const type = ref([
      {
        text: '與線上操作平台相關問題',
        value: '1',
      },
      {
        text: '需要專人解說詢問的題目',
        value: '2',
      },
      {
        text: '其他請說明',
        value: '3',
      },
    ])
    const messageType = ref('1')
    const questionContent = ref('')
    const userInfo = ref([
      {
        name: 'name',
        label: '姓名',
        placeholder: '請輸入姓名 ',
        type: 'text',
        value: undefined,
      },
      {
        name: 'company_name',
        label: '公司名稱',
        placeholder: '請輸入公司名稱 ',
        type: 'text',
        value: undefined,
      },
      {
        name: 'phone',
        label: '電話號碼',
        placeholder: '請輸入電話號碼 ',
        type: 'text',
        value: undefined,
      },
      {
        name: 'email',
        label: '電子郵件',
        placeholder: '請輸入電子郵件 ',
        type: 'text',
        value: undefined,
      },
    ])
    onMounted(async ()=>{
      const info = await getUserInfo()
      userInfo.value[0].value = info.ret.info.contact_person
      userInfo.value[1].value = info.ret.info.company_name
      userInfo.value[2].value = info.ret.info.mobile
      userInfo.value[3].value = info.ret.info.email
    })

    const formData = computed(() => {
      const info = userInfo.value.reduce(function (target, key) {
        target[key.name] = key.value
        return target
      }, {})
      info.content = questionContent.value
      info.category = type.value.find(e=>e.value === messageType.value).text
      return info
    })

    const submit = async () => {
      const res = await userContact(formData.value)
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        toggleLoading(false)
      } else {
        showMsgBox.value = true
        errorMsg.value = '傳送成功'
        setTimeout(()=>{
          router.push('/questionnaire')
        }, 1000)
      }
    }
    return {
      userInfo,
      errorCode,
      submit,
      showMsgBox,
      errorMsg,
      name,
      state,
      formList,
      showPhoto,
      image,
      showPassword,
      type,
      messageType,
      questionContent,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
.body {
  background-color: #fff;
  width: calc(100vw - 255px);
  padding: 0 40px;
  white-space: pre-line;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
  border: 1px solid #eff0f6;
  font-weight: 300;
}
.textarea {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
  border: 1px solid #eff0f6;
  border-radius: 20px;
  font-weight: 300;
  &::placeholder {
    color: #9ca0a8;
  }
}
.state {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #9ca0a8;
  font-weight: 300;
  border: 1px solid #eff0f6;
}
input::placeholder {
  font-size: 16px;
  color: #9ca0a8;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}
.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
.show-password {
  right: 32px;
  position: absolute;
  cursor: pointer;
}
.options {
  display: flex;
  align-items: center;
  width: 120px;
  color: #4d4d4d;
  font-size: 14px;
  margin: 5px 0;
}
.radio {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 999px;
  border: 1px solid #cccccc;
  padding: 4px;
  cursor: pointer;
}
.active {
  color: #177baf;
}
.radio-active {
  border: 1px solid #177baf;
  div {
    width: 100%;
    height: 100%;
    border-radius: 999px;
    background: #177baf;
  }
}
.content {
  padding: 80px 30px;
}
</style>
